import { ApiParameter, post } from "@insite/client-framework/Services/ApiService";
import { LockStepReceivableModel } from "@tFissco/ApiModels";

const lockstepreceivableUrl = "/api/v2/lockstepreceivable";

export interface LockStepReceivableApiParameter extends ApiParameter {
    onSuccess?: (response: any) => void;
    customerNumber: string;
    method: string;
}

export function submitLockStepReceivable(parameter: LockStepReceivableApiParameter) {
    return post<LockStepReceivableModel>(`${lockstepreceivableUrl}/`, parameter).then(response => {
        if (parameter.onSuccess) {
            parameter.onSuccess(response);
        }
    })
        .catch(error => {

            console.error("Error:", error);
        });;
}
